import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ProductSearchScoreData from "@insite/content-library/Components/ProductSearchScoreData";
import { ProductCardSelections } from "@insite/content-library/Widgets/ProductList/ProductCardSelections";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { ProductImageStyles } from "@stoneage/Overrides/Components/ProductImage";
import ProductListActions, {
    ProductListActionsStyles,
} from "@stoneage/Overrides/Widgets/ProductList/ProductListActions";
import ProductListProductImage from "@stoneage/Overrides/Widgets/ProductList/ProductListProductImage";
import ProductListProductInformation, {
    ProductListProductInformationStyles,
} from "@stoneage/Overrides/Widgets/ProductList/ProductListProductInformation";
import { horizontalProductCardSharedStyles } from "@stoneage/XDL/Utilities/SharedStyles/productCards";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = ProductCardSelections & HasProduct & { view: "List" | "Grid" };

export interface ProductListProductCardStyles {
    listCardWrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
    cardContentWrapper?: InjectableCss;
    cardActionsWrapper?: InjectableCss;
    productInformationStyles?: ProductListProductInformationStyles;
    productActionsStyles?: ProductListActionsStyles;
    productImage: ProductImageStyles;
}

export const productCardStyles: ProductListProductCardStyles = {
    listCardWrapper: {
        css: css`
            display: flex;
            margin-bottom: 24px;
            & :last-child {
                margin-bottom: 8px;
            }
        `,
    },
    imageWrapper: {
        css: css`
            width: 112px;
            ${({ view }: any) => (view === "List" ? "margin-right: 24px;" : "")}
        `,
    },
    cardContentWrapper: {
        css: css`
            display: flex;
            width: calc(100% - 136px);
        `,
    },
    cardActionsWrapper: {
        css: css`
            width: 284px;
            display: flex;
            align-items: flex-end;
            padding-left: 24px;
        `,
    },
    ...horizontalProductCardSharedStyles,
};

const styles = productCardStyles;

const ProductListProductCard: FC<Props> = props => {
    return (
        <StyledWrapper className="list-card-cont" {...styles.listCardWrapper}>
            <StyledWrapper className="list-card-image-cont" {...styles.imageWrapper} {...({ view: props.view } as any)}>
                <ProductListProductImage
                    showImage={props.showImage}
                    imageDimensions={props.view === "List" ? 112 : 308}
                    extendedStyles={styles.productImage}
                />
            </StyledWrapper>
            <StyledWrapper className="list-card-content-cont" {...styles.cardContentWrapper}>
                <ProductListProductInformation
                    showTitle={props.showTitle}
                    showPartNumbers={props.showPartNumbers}
                    showAvailability={props.showAvailability}
                    showAttributes={props.showAttributes}
                    extendedStyles={styles.productInformationStyles}
                    {...({ view: props.view } as any)}
                />
                <StyledWrapper {...styles.cardActionsWrapper}>
                    <ProductListActions
                        showCompare={props.showCompare}
                        showAvailability={props.showAvailability}
                        showPrice={props.showPrice}
                        showAddToCart={true}
                        extendedStyles={styles.productActionsStyles}
                        {...({ view: props.view } as any)}
                    />
                </StyledWrapper>
                <ProductSearchScoreData />
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default withProduct(ProductListProductCard);
